import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from '@els/els-react--modal';
import PropTypes from 'prop-types';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import IdleHandling from '@Services/IdleHandling';
import moment from 'moment-timezone';
import { typeOfIdleWarningModal } from './IdleWarningModalConstants';

import './IdleWarningModal.custom.scss';

function IdleWarningModal(props) {
  const { timeLeft } = props;
  const [currentTimeLeft, setTimeLeft] = useState(timeLeft);
  const dispatch = useDispatch();
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft > 1000) {
          return prevTimeLeft - 1000;
        }
        clearInterval(interval);
        // eslint-disable-next-line no-use-before-define
        sessionExpiry();
        return 0;
      });
    }, 1000);
    const sessionExpiry = () => {
      // eslint-disable-next-line no-use-before-define
      closeWindow();
      IdleHandling.processSessionExpiry();
    };
    return () => clearInterval(interval); // Cleanup interval on component unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTime = () => currentTimeLeft;

  function formatTimeLeft(milliseconds) {
    const duration = moment.duration(milliseconds);
    const formattedTime = moment.utc(duration.as('milliseconds')).format('mm:ss');
    return formattedTime;
  }

  const closeWindow = () => {
    dispatch(
      closeDialog({
        id: typeOfIdleWarningModal,
      })
    );
  };
  return (
    <Modal onClose={closeWindow} className="idle-warning-modal" id="idle-warning" shouldPreventClickOverlayToClose>
      <div>
        <h4>Warning</h4>
        <div className="idle-warning-content">
          Reaxys recognized no activity and will close the session in <b>{`${formatTimeLeft(getTime())} mm:ss`}</b>
        </div>
      </div>
    </Modal>
  );
}

IdleWarningModal.propTypes = {
  timeLeft: PropTypes.number.isRequired,
};

export default IdleWarningModal;
